import { createActions, createReducer } from 'reduxsauce'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    setExercicioConsultaAdiantamentosSuprimentos: ['exercicio'],
    setAdministracaoConsultaAdiantamentosSuprimentos: ['administracao'],
    setPeriodoUtilizacaoInicialConsultaAdiantamentosSuprimentos: ['periodoUtilizacaoInicial'],
    setPeriodoUtilizacaoFinalConsultaAdiantamentosSuprimentos: ['periodoUtilizacaoFinal'],
    setNomeConsultaAdiantamentosSuprimentos: ['nome'],
    setDocumentoConsultaAdiantamentosSuprimentos: ['documento'],
    limpaFiltroConsultaAdiantamentosSuprimentos: [],
    receberFiltroConsultaAdiantamentosSuprimentos: ['filtroRecebido'],
    setStatusConsultaAdiantamentosSuprimentos: ['status'],
})

const INITIAL_STATE = {
    exercicio: { value: new Date().getFullYear(), label: new Date().getFullYear() },
    administracao: '',
    periodoUtilizacaoInicial: '',
    periodoUtilizacaoFinal: '',
    nome: '',
    documento: '',
    status: { label: '', value: '' },
}

const setExercicio = (state = INITIAL_STATE, action) => {
    return { ...state, exercicio: action.exercicio }
}

const setAdministracao = (state = INITIAL_STATE, action) => {
    return { ...state, administracao: action.administracao }
}

const setPeriodoUtilizacaoInicial = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoInicial: action.periodoUtilizacaoInicial }
}

const setPeriodoUtilizacaoFinal = (state = INITIAL_STATE, action) => {
    return { ...state, periodoUtilizacaoFinal: action.periodoUtilizacaoFinal }
}

const setNome = (state = INITIAL_STATE, action) => {
    return { ...state, nome: action.nome }
}

const setDocumento = (state = INITIAL_STATE, action) => {
    return { ...state, documento: action.documento }
}

const limpaFiltro = (state = INITIAL_STATE, action) => {
    return INITIAL_STATE
}

const receberFiltro = (state = INITIAL_STATE, action) => {
    return action.filtroRecebido
}

const setStatus = (state = INITIAL_STATE, action) => {
    return { ...state, status: action.status }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.SET_EXERCICIO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setExercicio,
    [Types.SET_ADMINISTRACAO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setAdministracao,
    [Types.SET_PERIODO_UTILIZACAO_INICIAL_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setPeriodoUtilizacaoInicial,
    [Types.SET_PERIODO_UTILIZACAO_FINAL_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setPeriodoUtilizacaoFinal,
    [Types.SET_NOME_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setNome,
    [Types.SET_DOCUMENTO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setDocumento,
    [Types.LIMPA_FILTRO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: limpaFiltro,
    [Types.RECEBER_FILTRO_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: receberFiltro,
    [Types.SET_STATUS_CONSULTA_ADIANTAMENTOS_SUPRIMENTOS]: setStatus,
})
